import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './SideBar.css'
import LinksGroup from './LinksGroup'
import List from '@material-ui/core/List';
class Sidebar extends Component {

    render() {
        return (
            <div className={`sidebar c-sidebar c-sidebar-fixed ${this.props.SidebarOpen ? 'c-sidebar-lg-show mobile-nav' : 'hide'}`}>
                <div class="c-sidebar-brand d-lg-down-none">
                   <Link to="/">
                    <img src={process.env.PUBLIC_URL + '/logo.png'} alt=""/>
                   </Link>
                
                </div>
                <List component="nav" aria-labelledby="nested-list-subheader" >
                    <LinksGroup
                        id={1}
                        header="Dashboard"
                        headerLink="/app/main"
                        iconName="tachometer"
                    />
                      <LinksGroup
                        id={2}
                        header="Categories"
                        headerLink="/app/categories"
                        iconName="list"
                    />
                     <LinksGroup
                        id={3}
                        header="Image Gallery"
                        headerLink="/app/images/gallery"
                        iconName="image"
                    />
                      <LinksGroup
                        id={3}
                        header="Created Image"
                        headerLink="/app/created-image-list"
                        iconName="image"
                    />
                     <LinksGroup
                        id={4}
                        header="Users"
                        headerLink="/app/users"
                        iconName="users"
                    />
                      <LinksGroup
                        id={5}
                        header="User Queries"
                        headerLink="/app/user-queries"
                        iconName="envelope"
                    />
                     <LinksGroup
                        id={5}
                        header="Home Banner"
                        headerLink="/app/banner-update"
                        iconName="picture-o"
                    />
                     <LinksGroup
                        id={5}
                        header="Faqs"
                        headerLink="/app/Faqs"
                        iconName="question-circle"
                    />
                      <LinksGroup
                        id={5}
                        header="Sample Greetings"
                        headerLink="/app/sample-greetings"
                        iconName="hourglass-end"
                    />

                </List>
                
            </div>
        )
    }
}

export default Sidebar
